import React from "react";
import uuidv4 from "uuid/v4";
import { AttachmentHoc, CameraIconHoc, IconSmileHoc, 
        // mediaAudio, 
        SendMessageHoc } from "../../../../assets/images";
import Config from "../../../../config";
import MediaPreview from "../../../WebChat/MediaPreview/index.js";
import AudioRecorder from "../../Common/AudioRecorder.js";
import Modal from "../../Common/Modal";
import Attachement from "./Templates/Common/Attachement.js";
import ContentEditable from "./Templates/Common/ContentEditable.js";
import ReplyToMessage from "./Templates/SendMessage/ReplyToMessage";
import { CAMERA_PERMISSION_DENIED, PERMISSION_DENIED } from "../../../../processENV";
import SDK from "../../../../SDK";
import { getCameraPermission } from "./Templates/Common/Media.js";
import { TYPE_DELAY_TIME } from "../../../../Helpers/Constants";
import { blockOfflineMsgAction, isBoxedLayoutEnabled } from "../../../../Helpers/Utility";
import _get from "lodash-es/get";
import CustomIcon from "../../../../assets/images/CustomIcon";
import { useSelector } from "react-redux";
import _debounce from "lodash-es/debounce"
import { store } from "../../../../Redux/store";
import { UpdateTypedMessage } from "../../../../Redux/feature/chatConversationHistorySlice";
import { encryptAndStoreInLocalStorage } from "../../../../Helpers/Chat/webChatEncryptDecrypt";
import { formatUserIdToJid, getActiveChatMessages } from "../../../../Helpers/Chat/ChatHelper";

/**
// function debounce(func, wait, immediate) {
//     var timeout;
//     return function () {
//         var context = this,
//             args = arguments;
//         var later = function () {
//             timeout = null;
//             if (!immediate) func.apply(context, args);
//         };
//         var callNow = immediate && !timeout;
//         clearTimeout(timeout);
//         timeout = setTimeout(later, wait);
//         if (callNow) func.apply(context, args);
//     };
// }
*/

let typing = false,
    lastTypingTime = 0,
    emoji = false;

export const WebChatMessagesComposing = (props = {}) => {
    const otfHidden = false;
    const {
        avoidRecord,
        sendMessgeType = "",
        dragOnContainer = {},
        chatType = "", 
        jid = "",
        // popUpState = () => { },
        loaderStatus,
        forwardOption,
        closeReplyAction
    } = props;
    const storeselect = useSelector((state) => state);
    
    const { dynamicIcon, 
        vCardData = {}, 
        rosterData = {}, 
        groupMemberDetails = "",
        activeChatData = {}, 
        chatConversationHistory = {},
        featureFlagList:{data:{ 
        isAttachmentEnabled=true,
        isImageAttachmentEnabled=true,
        isVideoAttachmentEnabled=true,
        isAudioAttachmentEnabled=true,
        isDocumentAttachmentEnabled=true }}={}   } = storeselect;
    const { mf_IconSmile, mf_Attachment, 
    //mf_RecordAudio,
    mf_SendMessage } = dynamicIcon?.data
    let position = 0;
    let timeout = 0;
    /**
    // let selectedText = null;
    */
    let cameraPermissionTracks = [];

    const [webChatComposing, setWebChatComposing] = React.useState({
        showEmoji: false,
        typingMessage: "",
        selectedSlide: 0,
        seletedFiles: {},
        showCamera: false,
        cameraPermission: 0
    });
    const [showAttachement,setshowAttachement] = React.useState(false)
    const [showPreview,setShowPreview] = React.useState(false)
    const [recordingStatus,setrecordingStatus] = React.useState(true)
    encryptAndStoreInLocalStorage("recordingStatus", recordingStatus);
    const {
        showEmoji,
        typingMessage,
        selectedSlide,
        seletedFiles,
        showCamera,
        cameraPermission,
    } = webChatComposing;
    const placeCaretAtEnd = (el) => {
        el.focus();
        if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
            let range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false);
            let sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        } else if (typeof document.body.createTextRange != "undefined") {
            let textRange = document.body.createTextRange();
            textRange.moveToElementText(el);
            textRange.collapse(false);
            textRange.select();
        }
    };
    React.useEffect(() => {
        setWebChatComposing({
            ...webChatComposing
        });
    }, [dragOnContainer?.draggedId]);

    React.useEffect(() => {
        const messageContent = document.getElementById("typingContainer");
        messageContent && placeCaretAtEnd(messageContent);
        setWebChatComposing({
            ...webChatComposing});
    }, [sendMessgeType]);

    React.useEffect(() => {
        const messageContent = document.getElementById("typingContainer");
        typing = false;
        clearTimeout(timeout);
        if (messageContent) {
            if (chatType === "groupchat" || chatType === "chat") {
                const prevJid = getJid(chatType);
                goneStatus(prevJid);
            }
        }
        const { chatId = "" } = activeChatData.data[0]
        const { typedMessage = "" } = chatConversationHistory?.data[chatId] || {};
        setCursorPosition(typedMessage.length);
        setWebChatComposing({
            ...webChatComposing,
            typingMessage: typedMessage,
            showCamera: false
        }
        );
        document.getElementById('typingContainer').textContent = typedMessage;
        
        messageContent && placeCaretAtEnd(messageContent);
    }, [activeChatData?.data]);

    React.useEffect(() => {
        /**
        // const messageContent = document.getElementById("typingContainer");
        */
        const { chatId = "" } = activeChatData.data[0];
        if (chatId) {
            const { typedMessage = "" } = chatConversationHistory?.data[chatId] || {};
            setWebChatComposing({
                ...webChatComposing,
                typingMessage: typedMessage
            }
            );
        }
    }, []);
    const setCursorPosition = (pos) => {
     position = typeof pos === "undefined" ? 0 : pos;
    };
    const handleMessage = (event = {}) => {
        const { value = "" } = _get(event, "target", {});
        // Here '\n' compare with string length 1 instead of 2
        // Because when we use shift+enter to go next line, this '\n'
        // consider as single text not two chars. That's when value length 1 &
        // value is '\n', set empty data to typingMessage to display the mic button
        // instead of send message button
        setWebChatComposing({
            ...webChatComposing,
            typingMessage:
                (typingMessage.length === 0 && (value.trim().length === 0 || value === "&nbsp;")) ||
                    (value.length === 1 && value === "\n")
                    ? ""
                    : value
                }
        );       
        store.dispatch(UpdateTypedMessage({ chatId: jid, message: value }));
    };

    /**
    // const setCursorPosition = (pos) => {
    //     position = typeof pos === "undefined" ? 0 : pos;
    // };

    // const handleSetSelectedText = (selectedTextHandleSet) => {
    //     selectedText = selectedTextHandleSet;
    // };
    */

    const handleEmptyContent = () => {
        setWebChatComposing({
            ...webChatComposing,
            typingMessage: ""
        })
    }

    const handleSendMSG = (messageType, messageContent) => {
        let message;
        const { loaderStatus:loaderStatusSendMsg, handleSendMsg } = props;
        if (loaderStatusSendMsg) return;
        if (messageType === "text") {
            message = {
                type: "text",
                content: messageContent.toString().replace(/<br>/g, "\n").trim()
            };
        } else if (messageType === "media") {
            message = {
                type: "media",
                content: messageContent
            };
        }
        setWebChatComposing({
            ...webChatComposing,
            typingMessage: "",
            showEmoji: false ,
        });
        setshowAttachement(false)
        setShowPreview(false);
        handleSendMsg(message);
        store.dispatch(UpdateTypedMessage({ chatId: jid, message: "" }));

        // setTimeout(() => {
            setWebChatComposing({ ...webChatComposing, typingMessage: "" })
        // }, 250);
    };

    const handleSendTextMsg = (event = {}) => {
        handleSendMSG("text", typingMessage);
    };

    const handleSendMediaMsg = (Media) => {
        handleSendMSG("media", Media);
    };

    const toggleAttachement = () => {
        setWebChatComposing({
            ...webChatComposing,
            showEmoji: false,
        }
        );
        setshowAttachement(!showAttachement)
    };

    const onCloseAttachment = () => {
        setshowAttachement(false)
    };

    const handleShowHidePreview = () => {
        setWebChatComposing({
            ...webChatComposing,
            selectedSlide: 0 });
        setshowAttachement(false)
        setShowPreview(!showPreview);
    };

    const handleSelectFile = (event, mediaType) => {
        setWebChatComposing({
            ...webChatComposing,
                seletedFiles: {
                filesId: uuidv4(),
                files: event.target.files,
                mediaType
            }
        });
        setShowPreview(true);
    }; 

    const handleRecordingStatus = (status) => {
        encryptAndStoreInLocalStorage("recordingStatus", status);
        setrecordingStatus(status);
        /**
        // setWebChatComposing({
        //     ...webChatComposing,
        //     recordingStatus: status
        // });
        */
    };

    const handleShowEmojis = () => {
        setWebChatComposing({
            ...webChatComposing,
            showEmoji: !showEmoji}
        );
        setshowAttachement(false)

    };

    const typingStopped = () => {
        if (!typing) {
            return;
        }
        typing = false;
        const { chatType:chatTypeTypo, jid:jidTypo } = props;
        const updatedJid = getJid(chatTypeTypo, jidTypo);
        goneStatus(updatedJid);
    };

    const typingStarted = function () {
        typing = true;
        if (typingMessage.length + 1 !== 0 && Date.now() - lastTypingTime > TYPE_DELAY_TIME) {
            lastTypingTime = Date.now();
            sentTypingstatus();
        }
    };

    const delay = () => {        
        typingStarted();
        _debounce(()=>typingStopped(), TYPE_DELAY_TIME);
    };
    
    const goneStatus = (jidGoneStatus) => {
        SDK.sendTypingGoneStatus(jidGoneStatus);
    };

    const getJid = (chatTypeGetJid, jidGetJid) => {
        return formatUserIdToJid(jidGetJid,chatTypeGetJid)
    };

    const sentTypingstatus = () => {
        if (!(chatType === "groupchat" || chatType === "chat")) {
            return;
        }
        let userJid = getJid(chatType, jid);
        SDK.sendTypingStatus(userJid);
    };

    const handleOnFocus = (e) => {
        showAttachement && setshowAttachement(false);
    };

    const isTypingMessageHasData = () => {
        return typingMessage || "".trim().length > 0;
    };

    /**
    // const updateEmojiPopUpState = () => {
    //     popUpState({
    //         name: "smileyPopUp",
    //         smileyPopUp: {
    //             active: showEmoji
    //         }
    //     });
    // };
    */

    const closeCamera = () => {
        stopCameraPermissionTracks();
        setWebChatComposing({
            ...webChatComposing,
            showCamera: false
        });
    };

    const handleCameraTakenFile = (file) => {
        if (blockOfflineMsgAction()) return;
        file.fileDetails = {};
        handleSendMediaMsg([file]);
        closeCamera();
    };

    const toggleCamera = async () => {
        setshowAttachement(false);
        const permissionResult = await getCameraPermission();
        cameraPermissionTracks = permissionResult || [];
        setWebChatComposing({ ...webChatComposing, cameraPermission: permissionResult ? 1 : 2 });

        if (permissionResult)
            setWebChatComposing({
                ...webChatComposing,
                showCamera: !showCamera
            });
    };

    const stopCameraPermissionTracks = () => {
        const tracks = cameraPermissionTracks;
        Array.isArray(tracks) &&
            tracks.forEach(function (track) {
                track.stop();
            });
        cameraPermissionTracks = [];
    };

    const handleCameraPopupClose = () => {
        setWebChatComposing({
            ...webChatComposing,
            showCamera: false,
            cameraPermission: 0
        });
    };

    const renderCameraPopup = () => {
        return (
            <div className="camera-container mediaAttachCamera">
                <div className="camera-popup">
                    <h4>{PERMISSION_DENIED}</h4>
                    <i>
                        <CameraIconHoc />
                    </i>
                    <p>{CAMERA_PERMISSION_DENIED}</p>
                    <div className="popup-controls">
                        <button
                            type="button"
                            className="btn-okay"
                            onClick={(e) => handleCameraPopupClose()}
                            name="btn-cancel"
                        >
                            {"Okay"}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    const renderCameraCapture = () => {
        return (
            <Camera
                stopCameraPermissionTracks={stopCameraPermissionTracks}
                onClickClose={closeCamera}
                cropEnabled={false}
                onSuccess={handleCameraTakenFile}
            />
        );
    };
    const findReply = (reply_jid = "") => {
        const activeChat = getActiveChatMessages()
        const clearReplayChat = activeChat.length > 0 ? true : false
        const { userReplayDetails = [] } = props;
        const auto_Replay = userReplayDetails.some(
          (ele) => _get(ele, "roster.userId", "") === reply_jid || _get(ele, "roster.groupId", "") === reply_jid
        );
        const auto_Msgfind = userReplayDetails.find(
          (ele) => _get(ele, "roster.userId", "") === reply_jid || _get(ele, "roster.groupId", "") === reply_jid
        );
        const { replyMessages = {} } = auto_Msgfind || {};
        return { autoReplay: auto_Replay, autoMsgfind: replyMessages,clearReplay: clearReplayChat};
    };
    const { autoReplay = false, autoMsgfind = {} ,clearReplay } = findReply(jid);

    return (
        <footer className={`footer `}>
            {autoReplay ? (
                <ReplyToMessage
                replyMessage={autoMsgfind}
                vCardData={vCardData}
                clearReplay={clearReplay}
                rosterData={rosterData}
                closeReplyAction={closeReplyAction}
                groupMemberDetails={groupMemberDetails}
                jid={jid}
                />
            ) : null}

            {recordingStatus && Config.attachement && showAttachement && isAttachmentEnabled && 
                ( isImageAttachmentEnabled || isVideoAttachmentEnabled ||isAudioAttachmentEnabled || isDocumentAttachmentEnabled) && ( 
                <Attachement
                    selectFile={handleSelectFile}
                    onclose={toggleAttachement}
                    closeAttachment={onCloseAttachment}
                    handleSendMediaMsg={handleSendMediaMsg}
                    toggleCamera={toggleCamera}
                    imageAttachmentFlag = { isImageAttachmentEnabled }
                    videoAttachmentFlag = { isVideoAttachmentEnabled }
                    audioAttachmentFlag = { isAudioAttachmentEnabled }
                    docAttachmentFlag = { isDocumentAttachmentEnabled }
                />
            )}

            {showCamera && (
                <>
                    {isBoxedLayoutEnabled() ?
                        <>
                            <Modal containerId="container">
                                {renderCameraCapture()}
                            </Modal>
                        </>
                        :
                        <>
                            {renderCameraCapture()}
                        </>
                    }
                </>
            )}

            {cameraPermission === 2 && (
                <>
                    {isBoxedLayoutEnabled() ?
                        <Modal containerId="container">
                            {renderCameraPopup()}
                        </Modal>
                        :
                        <>
                            {renderCameraPopup()}
                        </>
                    }
                </>
            )}

            {showPreview && (
                <Modal containerId="container">
                    <MediaPreview
                        seletedFiles={seletedFiles}
                        jid={jid}
                        selectedSlide={selectedSlide}
                        onClosePreview={handleShowHidePreview}
                        onClickSend={handleSendMediaMsg}
                    />
                </Modal>
            )}
            <form style={{ visibility: forwardOption ? "hidden" : " " }} className="message-area-container">
                <div className="message-area">
                    {emoji && <i
                        className="em em-slightly_smiling_face"
                        data-tag="toggle-emojis-popup"
                        onClick={handleShowEmojis}
                    >
                        <CustomIcon
                            icon={mf_IconSmile ? mf_IconSmile : <IconSmileHoc viewBox="0 0 25.249 25.236" />}
                            {...props}
                        />                   
                    </i>}
                    <ContentEditable
                        loaderStatus={loaderStatus}
                        html={typingMessage}
                        id="typingContainer"
                        onInputListener={delay}
                        jid={jid}
                        chatType={chatType}
                        handleMessage={handleMessage}
                        handleSendTextMsg={handleSendTextMsg}
                        handleOnFocus={handleOnFocus}
                        // setCursorPosition={setCursorPosition}

                        /**
                        // setCursorPosition={setCursorPosition}
                        // setSelectedText={handleSetSelectedText}
                        */
                        handleEmptyContent={handleEmptyContent}
                    />
                    <div className="intraction icon">
                        {recordingStatus && Config.attachement && isAttachmentEnabled &&
                            ( isImageAttachmentEnabled || isVideoAttachmentEnabled ||isAudioAttachmentEnabled || isDocumentAttachmentEnabled) &&(
                            <i
                                title="Attachment"
                                className={showAttachement ? "attachment open" : "attachment"}
                                onClick={toggleAttachement}
                            >
                                <span className="toggleAnimation"></span>
                                <CustomIcon
                                    icon={mf_Attachment !== "" ? mf_Attachment : <AttachmentHoc viewBox="0 0 20 20"/>}
                                    {...props}
                                />
                            </i>
                        )}
                    </div>
                </div>
                {!isTypingMessageHasData() && isAudioAttachmentEnabled && otfHidden && (
                    <AudioRecorder
                        jid={jid}
                        handleSendMediaMsg={handleSendMediaMsg}
                        recordingStatus={handleRecordingStatus}
                        avoidRecord={avoidRecord}
                        // iconSet={ mf_RecordAudio }
                    />
                )}
                {(
                    <div className="formbtns">
                        <a type="submit" className="send">
                            <i title="Send" className="send" onClick={handleSendTextMsg}>
                            <CustomIcon
                                icon={mf_SendMessage ? mf_SendMessage : <SendMessageHoc viewBox="0 0 20 20"/>}
                                {...props}
                            />
                            </i>
                        </a>
                    </div>
                )}
            </form>
        </footer>
    );
}


export default WebChatMessagesComposing;
